import { DateTimeFormatter } from '@nile/components/src';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';

const BlockEvent = (props) => {
  return (
    <div className="block-event f-12 lh-18">
      <div className="flex g3 ">
        <div>
          <TextStyle>
            <DateTimeFormatter type="time" date={props?.event?.start} />
          </TextStyle>
        </div>

        <div>-</div>

        <div>
          <TextStyle>
            <DateTimeFormatter type="time" date={props?.event?.end} />
          </TextStyle>
        </div>
      </div>
    </div>
  );
};

export default BlockEvent;
